import type { AssetSource } from "@skilitics/assets";
import type { MediaAssetValue } from "@skilitics/designer-ui-components";

export const mediaAssetToAssetSource = <T extends MediaAssetValue | undefined>(asset?: T): AssetSource | undefined =>
  asset
    ? // handle the wonky realities of source redundant prop not being rolled out everyhwere
      asset.source === "file" || ("assetId" in asset && typeof asset.assetId === "string")
      ? { assetId: asset.assetId as string, name: "name" in asset ? (asset.name ?? "") : "" }
      : { url: asset.url }
    : undefined;

export const assetSourceToMediaAsset = <T extends AssetSource | undefined>(source: T): MediaAssetValue | undefined =>
  source ? ("assetId" in source ? { source: "file", ...source } : { source: "url", ...source }) : undefined;

export const assetToMediaAsset = <T extends { source: AssetSource }>(
  asset: T | undefined | null,
): MediaAssetValue | undefined =>
  asset
    ? "assetId" in asset.source
      ? { source: "file", assetId: asset.source.assetId, name: asset.source.name }
      : { source: "url", url: asset.source.url }
    : undefined;
